import React from "react";
import { StyleSheet, Text as RNText, View } from "react-native";
import { useTheme } from "@react-navigation/native";
import { Theme } from "@theme";
import { GroupAvatar } from "./GroupAvatar";
import { useGetContactsByIds } from "@hooks";

interface EventParticipantsProps {
  participantAccountIds: string[];
}

export const EventParticipants = ({ participantAccountIds }: EventParticipantsProps) => {
  const theme = useTheme();
  const styles = getStyles(theme);
  const { contacts } = useGetContactsByIds(participantAccountIds);

  const participantNames = participantAccountIds
    .map(item => contacts.find(c => c.id === item)?.fullName)
    .filter(Boolean)
    .join(', ');

  const profiles = participantAccountIds.map(id => {
    const contact = contacts.find(c => c.id === id);
    return {
      id,
      avatarUrl: contact?.avatarUrl,
    };
  });

  return (
    <View style={styles.eventDetailRow}>
      <GroupAvatar profiles={profiles} />
      <RNText style={styles.eventDetailText}>
        {participantNames}
      </RNText>
    </View>
  );
};

const getStyles = (theme: Theme) => StyleSheet.create({
  eventDetailRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 6,
  },
  eventDetailText: {
    fontSize: 15,
    color: '#8E8E93',
  },
});

